import { ReduceStore } from 'flux/utils';
import Dispatcher from '../dispatcher';
import ACTION_TYPES from '../constants/action_types';
import { actions } from '../constants/product_mixed_stocks/actions';
import Cart from './models/cart';
import FittingOption from './models/fitting_option';
import ShippingOption from './models/shipping_option';
import ShippingAddress from './models/shipping_address';
import Order from './models/order';
import PAYMENT_STATUSES from '../constants/payment_statuses';
import {isEqual} from '../../../lib/utilities';
class ProductMixedStocksLightboxStoreClass extends ReduceStore {
    getInitialState() {
        return {
            visible: false,
            cart: null,
            fittingOptions: [],
            shippingOptions: [],
            fittingPriceInDetailModes: [],
            order: null,
            quantity: 0,
            errorMessage: null,
            postcodeLayerVisible: true,
            productLayerVisible: false,
            orderFormLayerVisible: false,
            orderStatusLayerVisible: false,
            shippingAddressFormLayerVisible: false,
            itemPriceDetailsVisible: false,
            shippingPriceDetailsVisible: false,
            withoutFittingOption: false,
            noFittingShippingAddressSummaryVisible: false,
            noFittingShippingAddressInputVisible: false,
            paymentStatus: PAYMENT_STATUSES.NEW,
            timerIntervalId: null,
            fittingServices: [],
        };
    }

    reduce(state, { source, action }) {
        if (source === ACTION_TYPES.PRODUCT_MIXED_STOCKS_LIGHTBOX_ACTION) {
            switch (action.type) {
                case actions.SHOW:
                    if (!state.visible) {
                        state.visible = true;
                        this.__emitChange();
                    }
                    break;

                case actions.HIDE:
                    if (state.visible) {
                        state.visible = false;
                        this.__emitChange();
                    }
                    break;

                // Handle postcode layer visibility
                case actions.SHOW_POSTCODE_LAYER:
                    if (!state.postcodeLayerVisible) {
                        state.postcodeLayerVisible = true;
                        this.__emitChange();
                    }
                    break;

                case actions.HIDE_POSTCODE_LAYER:
                    if (state.postcodeLayerVisible) {
                        state.postcodeLayerVisible = false;
                        this.__emitChange();
                    }
                    break;

                // Handle no fitting shipping address visibility
                case actions.SHOW_NO_FITTING_SHIPPING_ADDRESS_SUMMARY:
                    if (!state.noFittingShippingAddressSummaryVisible) {
                        state.noFittingShippingAddressSummaryVisible = true;
                        this.__emitChange();
                    }
                    break;

                case actions.HIDE_NO_FITTING_SHIPPING_ADDRESS_SUMMARY:
                    if (state.noFittingShippingAddressSummaryVisible) {
                        state.noFittingShippingAddressSummaryVisible = false;
                        this.__emitChange();
                    }
                    break;

                // Handle no fitting shipping address input detail visibility
                case actions.SHOW_NO_FITTING_SHIPPING_ADDRESS_INPUT:
                    if (!state.noFittingShippingAddressInputVisible) {
                        state.noFittingShippingAddressInputVisible = true;
                        this.__emitChange();
                    }
                    break;

                // Handle product layer visibility
                case actions.SHOW_PRODUCT_LAYER:
                    if (!state.productLayerVisible) {
                        state.productLayerVisible = true;
                        this.__emitChange();
                    }
                    break;
                case actions.HIDE_PRODUCT_LAYER:
                    if (state.productLayerVisible) {
                        state.productLayerVisible = false;
                        this.__emitChange();
                    }
                    break;

                // Handle Quantity
                case actions.SET_QUANTITY:
                    if (state.quantity !== action.payload) {
                        state.quantity = parseInt(action.payload);
                        this.__emitChange();
                    }
                    break;
                case actions.RESET_QUANTITY:
                    state.quantity = 0;
                    this.__emitChange();
                    break;

                // Handle MixedStocks
                case actions.SET_CART:
                    if (!isEqual(state.cart, action.payload)) {
                        state.cart = new Cart(action.payload);
                        this.__emitChange();
                    }
                    break;
                case actions.UNSET_CART:
                    state.cart = null;
                    this.__emitChange();
                    break;

                // Handle FittingOptions
                case actions.SET_FITTING_OPTIONS:
                    if (!isEqual(state.fittingOptions, action.payload)) {
                        state.fittingOptions = [];
                        action.payload.map((payload) => {
                            const fittingOption = new FittingOption(payload);
                            state.fittingOptions.push(fittingOption);
                        });
                        this.__emitChange();
                    }
                    break;
                case actions.UNSET_FITTING_OPTIONS:
                    state.fittingOptions = [];
                    this.__emitChange();
                    break;

                // Handle ItemPriceDetails visibility
                case actions.SHOW_ITEM_PRICE_DETAILS:
                    if (!state.itemPriceDetailsVisible) {
                        state.itemPriceDetailsVisible = true;
                        this.__emitChange();
                    }

                    break;

                case actions.HIDE_ITEM_PRICE_DETAILS:
                    if (state.itemPriceDetailsVisible) {
                        state.itemPriceDetailsVisible = false;
                        this.__emitChange();
                    }

                    break;

                // Handle ShippingOptions
                case actions.SET_SHIPPING_OPTIONS:
                    if (!isEqual(state.shippingOptions, action.payload)) {
                        state.shippingOptions = [];
                        action.payload.map((payload) => {
                            const shippingOption = new ShippingOption(payload);
                            state.shippingOptions.push(shippingOption);
                        });
                        this.__emitChange();
                    }
                    break;
                case actions.UNSET_SHIPPING_OPTIONS:
                    state.shippingOptions = [];
                    this.__emitChange();
                    break;

                // Handle shippingPriceDetailsVisible visibility
                case actions.SHOW_SHIPPING_PRICE_DETAILS:
                    if (!state.shippingPriceDetailsVisible) {
                        state.shippingPriceDetailsVisible = true;
                        this.__emitChange();
                    }

                    break;

                case actions.HIDE_SHIPPING_PRICE_DETAILS:
                    if (state.shippingPriceDetailsVisible) {
                        state.shippingPriceDetailsVisible = false;
                        this.__emitChange();
                    }

                    break;

                // Handle shipping address form visibility (no fitting)
                case actions.SHOW_SHIPPING_ADDRESS_FORM_LAYER:
                    if (!state.shippingAddressFormLayerVisible) {
                        state.shippingAddressFormLayerVisible = true;
                        this.__emitChange();
                    }

                    break;

                case actions.HIDE_SHIPPING_ADDRESS_FORM_LAYER:
                    if (state.shippingAddressFormLayerVisible) {
                        state.shippingAddressFormLayerVisible = false;
                        this.__emitChange();
                    }

                    break;

                // Handle order form visibility
                case actions.SHOW_ORDER_FORM_LAYER:
                    if (!state.orderFormLayerVisible) {
                        state.orderFormLayerVisible = true;
                        this.__emitChange();
                    }

                    break;

                case actions.HIDE_ORDER_FORM_LAYER:
                    if (state.orderFormLayerVisible) {
                        state.orderFormLayerVisible = false;
                        this.__emitChange();
                    }

                    break;
                // Handle order status confirmation visibility
                case actions.SHOW_ORDER_STATUS_LAYER:
                    if (!state.orderStatusLayerVisible) {
                        state.orderStatusLayerVisible = true;
                        this.__emitChange();
                    }

                    break;

                case actions.HIDE_ORDER_STATUS_LAYER:
                    if (state.orderStatusLayerVisible) {
                        state.orderStatusLayerVisible = false;
                        this.__emitChange();
                    }

                    break;

                // Handle Order Data
                case actions.SET_ORDER:
                    if (!isEqual(state.order, action.payload)) {
                        state.order = new Order(action.payload);
                        this.__emitChange();
                    }
                    break;
                case actions.UNSET_ORDER:
                    if (!isEqual(state.order, action.payload)) {
                        state.order = null;
                        this.__emitChange();
                    }
                    break;
                // Handle Error Message
                case actions.SET_ERROR_MESSAGE:
                    if (!isEqual(state.errorMessage, action.payload)) {
                        state.errorMessage = action.payload;
                        this.__emitChange();
                    }
                    break;
                case actions.UNSET_ERROR_MESSAGE:
                    if (!isEqual(state.errorMessage, action.payload)) {
                        state.errorMessage = null;
                        this.__emitChange();
                    }
                    break;
                // Handle FittingPrice Detail Mode
                case actions.SET_FITTING_PRICE_IN_DETAIL_MODE:
                    if (state.fittingPriceInDetailModes.indexOf(action.payload) < 0) {
                        state.fittingPriceInDetailModes.push(action.payload);
                        this.__emitChange();
                    }
                    break;
                case actions.UNSET_FITTING_PRICE_IN_DETAIL_MODE:
                    state.fittingPriceInDetailModes = [];
                    this.__emitChange();
                    break;
                // Handle selected fittingOption
                case actions.SET_SELECTED_FITTING_OPTION:
                    if (!isEqual(state.cart.shippingAddress.fsId, action.payload)) {
                        const selectedFsId = action.payload;
                        state.fittingOptions.map((fittingOption) => {
                            if (selectedFsId === fittingOption.fs.fsId) {
                                state.cart.shippingAddress = new ShippingAddress(fittingOption.fs.address);
                                state.cart.shippingAddress.fsId = fittingOption.fs.fsId;
                                state.cart.shippingAddress.isFittingStationAddress = true;
                            }
                        });
                        this.__emitChange();
                    }
                    break;
                case actions.UNSET_SELECTED_FITTING_OPTION:
                    state.cart.shippingAddress.fsId = null;
                    state.cart.shippingAddress.isFittingStationAddress = false;
                    this.__emitChange();
                    break;
                // Handle selected with or without fitting option
                case actions.SET_WITHOUT_FITTING_OPTION:
                    if (!isEqual(state.withoutFittingOption, action.payload)) {
                        state.withoutFittingOption = true;
                        this.__emitChange();
                    }
                    break;
                case actions.UNSET_WITHOUT_FITTING_OPTION:
                    if (!isEqual(state.withoutFittingOption, action.payload)) {
                        state.withoutFittingOption = false;
                        this.__emitChange();
                    }
                    break;
                // Handle payment status
                case actions.SET_PAYMENT_STATUS:
                    if (!isEqual(state.paymentStatus, action.payload)) {
                        state.paymentStatus = action.payload;
                        this.__emitChange();
                    }
                    break;
                case actions.UNSET_PAYMENT_STATUS:
                    state.paymentStatus = PAYMENT_STATUSES.NEW;
                    this.__emitChange();
                    break;
                // Handle timer interval used in payment check
                case actions.SET_TIMER_INTERVAL_ID:
                    if (!isEqual(state.timerIntervalId, action.payload)) {
                        state.timerIntervalId = action.payload;
                        this.__emitChange();
                    }
                    break;
                case actions.UNSET_TIMER_INTERVAL_ID:
                    state.timerIntervalId = null;
                    this.__emitChange();
                    break;
                // Handle selected fitting services
                case actions.ADD_FITTING_SERVICE:
                    if (state.fittingServices.indexOf(action.payload) < 0) {
                        state.fittingServices.push(action.payload);
                        this.__emitChange();
                    }
                    break;
                case actions.REMOVE_FITTING_SERVICE:
                    if (state.fittingServices.indexOf(action.payload) > -1) {
                        state.fittingServices.splice(
                            state.fittingServices.indexOf(action.payload),
                            1
                        );
                        this.__emitChange();
                    }
                    break;
                case actions.CLEAR_FITTING_SERVICE:
                    state.fittingServices = [];
                    this.__emitChange();
                    break;
                }

        }

        return state;
    }
}

const ProductMixedStocksLightboxStore = new ProductMixedStocksLightboxStoreClass(Dispatcher);
export default ProductMixedStocksLightboxStore;